<template>
  <transition name="desktop-notice-fade">
    <div v-if="notice" class="desktop-notice-mask" @click.self="close">
      <div class="desktop-notice-card" role="dialog" :aria-label="notice.title">
        <button class="desktop-notice-close" type="button" aria-label="关闭" @click="close">×</button>
        <h3 class="desktop-notice-title">{{ notice.title }}</h3>
        <p class="desktop-notice-text">{{ notice.message }}</p>
        <a class="desktop-notice-btn" :href="downloadUrl" @click="onDownloadClick">{{ notice.buttonText }}</a>
        <button class="desktop-notice-later" type="button" @click="close">{{ notice.laterText }}</button>
      </div>
    </div>
  </transition>
</template>

<script>
import {
  detectDesktopEnv,
  isMacOsUserAgent,
  pickMacDownloadUrl,
  resolveWorkbenchDownloadInfo,
  resolveWorkbenchMacDownloadInfo,
} from '@/utils/desktopEnv';
import { MACDESK_ARM64, WINDOWDESK } from '@/assets/constant/default';

function readQuery(name) {
  try {
    if (typeof URLSearchParams !== 'undefined') {
      return new URLSearchParams(window.location.search).get(name);
    }
  } catch (e) {
    return null;
  }
  return null;
}

export default {
  name: 'DesktopNotice',
  data() {
    return {
      notice: null,
      downloadUrl: isMacOsUserAgent() ? MACDESK_ARM64 : WINDOWDESK,
    };
  },
  created() {
    this.bootstrap();
  },
  methods: {
    async bootstrap() {
      // QA：?legacyBanner=1/0 强制展示/隐藏旧版停服弹窗
      const legacyOverride = readQuery('legacyBanner');
      const [winInfo, macInfo] = await Promise.all([
        resolveWorkbenchDownloadInfo(),
        resolveWorkbenchMacDownloadInfo(),
      ]);
      const onMac = isMacOsUserAgent();
      this.downloadUrl = onMac ? pickMacDownloadUrl(macInfo) : winInfo.url;

      const env = detectDesktopEnv();
      if (legacyOverride !== '0' && (env.isLegacyDesktop || legacyOverride === '1')) {
        this.notice = {
          title: '旧版「嗨喵桌面」已停止维护',
          message: '您正在使用的旧版嗨喵桌面不再接收更新与维护，互动功能已全面迁移至全新「嗨喵工作台」，请下载新版继续使用。',
          buttonText: '免费下载新版工作台',
          laterText: '暂不下载',
        };
      }
    },
    onDownloadClick() {
      this.notice = null;
    },
    close() {
      this.notice = null;
    },
  },
};
</script>

<style scoped lang="less">
.desktop-notice-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(30, 21, 12, 0.55);
}
.desktop-notice-card {
  position: relative;
  width: 420px;
  max-width: calc(100% - 40px);
  padding: 30px 28px 24px;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 24px 64px rgba(30, 21, 12, 0.3);
  text-align: center;
}
.desktop-notice-close {
  position: absolute;
  top: 10px;
  right: 12px;
  width: 30px;
  height: 30px;
  border: none;
  background: transparent;
  color: #a2937f;
  font-size: 20px;
  line-height: 30px;
  cursor: pointer;
}
.desktop-notice-close:hover {
  color: #2d2318;
}
.desktop-notice-title {
  margin: 0 0 10px;
  color: #2d2318;
  font-size: 19px;
  line-height: 1.4;
}
.desktop-notice-text {
  margin: 0 0 20px;
  color: #75685a;
  font-size: 13px;
  line-height: 1.8;
  text-align: left;
}
.desktop-notice-btn {
  display: block;
  height: 44px;
  line-height: 44px;
  border-radius: 999px;
  background: linear-gradient(145deg, #f79420, #e85a12);
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  box-shadow: 0 6px 16px rgba(236, 106, 16, 0.3);
  cursor: pointer;
}
.desktop-notice-btn:hover {
  color: #fff;
  background: linear-gradient(145deg, #ef8312, #d54e0a);
}
.desktop-notice-later {
  margin-top: 12px;
  border: none;
  background: transparent;
  color: #a2937f;
  font-size: 12px;
  cursor: pointer;
}
.desktop-notice-later:hover {
  color: #75685a;
}
.desktop-notice-fade-enter-active {
  transition: opacity 0.2s ease;
}
.desktop-notice-fade-enter-active .desktop-notice-card {
  transition: transform 0.2s ease;
}
.desktop-notice-fade-enter {
  opacity: 0;
}
.desktop-notice-fade-enter .desktop-notice-card {
  transform: translateY(10px);
}
.desktop-notice-fade-leave-active {
  transition: opacity 0.15s ease;
}
.desktop-notice-fade-leave-to {
  opacity: 0;
}
@media (max-width: 520px) {
  .desktop-notice-card {
    padding: 24px 20px 20px;
  }
}
</style>
